<template>
  <div v-title="$route.meta.title"
       class="training-instruction-record">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/training/instruction' }">培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <training-instruction-sub-heading :title="pageHeadingTitle"
                                      :entity-id="instruction.id" />

    <div class="training-instruction-record__card training-instruction-record__card--search">
      <div class="training-instruction-record__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="training-instruction-record__search-form"
               @submit.native.prevent="onSearch()">
        <div class="training-instruction-record__search-grid">
          <el-form-item label="关键字"
                        prop="keyword">
            <el-input v-model="search.keyword"
                      placeholder="请输入真实姓名或ID"
                      clearable />
          </el-form-item>
          <el-form-item label="培训状态"
                        prop="instruction_record_status">
            <el-select v-model="search.instruction_record_status"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.recordStatusMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型"
                        prop="target_usertype">
            <el-select v-model="search.target_usertype"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in targetUserMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="来源"
                        prop="source_type">
            <el-select v-model="search.source_type"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.sourceTypeMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目 名称/编号 进行搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail"
                           @change="search.batchid = null" />
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           :disabled="!search.projectid"
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请输入批次 名称/编号 进行搜索"
                           v-model="search.batchid"
                           :query-request="(_) => getBatchTable(Object.assign({ projectid: search.projectid }, _))"
                           :find-request="getBatchDetail" />
          </el-form-item>
          <el-form-item label="省市区"
                        prop="regionids">
            <el-cascader v-model="search.regionids"
                         class="width-max"
                         :options="chinaAreaData"
                         :props="{ multiple: true, checkStrictly: true }"
                         filterable
                         clearable
                         placeholder="请选择省市区" />
          </el-form-item>
          <el-form-item label="完成学习"
                        prop="learning_finished_at">
            <el-date-picker v-model="search.learning_finished_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
          <el-form-item label="考试提交"
                        prop="examination_submitted_at">
            <el-date-picker v-model="search.examination_submitted_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
        </div>
        <div class="training-instruction-record__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
<!--          二期再做导出-->
<!--          <el-button type="info"-->
<!--                     icon="el-icon-download"-->
<!--                     @click="onExport()">导出进度</el-button>-->
        </div>
      </el-form>
    </div>

    <div class="training-instruction-record__card">
      <div class="training-instruction-record__card-header"
           @click="listExpanded = !listExpanded">
        <span>用户培训记录</span>
        <div class="training-instruction-record__card-header-actions">
          <el-button type="text"
                     icon="el-icon-setting"
                     class="training-instruction-record__header-action"
                     title="列配置"
                     @click.stop="openTableColumnConfigDialog" />
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="training-instruction-record__header-action"
                     @click.stop="onRefresh()" />
          <span class="training-instruction-record__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="training-instruction-record__list-body">
        <div class="training-instruction-record__table-wrap">
          <el-table :key="tableColumnRenderKey"
                    :data="table"
                    class="training-instruction-record__table"
                    style="width: 100%">
            <el-table-column v-for="field in activeTableFields"
                             :key="field.key"
                             v-bind="getFieldColumnBind(field)">
              <template slot-scope="scope">
                <span v-if="field.slot === 'tag'">
                  <span v-if="field.formatter(scope.row)"
                        :class="['training-instruction-record__tag', field.tagClass(scope.row)]">
                    {{ field.formatter(scope.row) }}
                  </span>
                  <span v-else
                        class="training-instruction-record__empty">-</span>
                </span>
                <template v-else-if="field.slot === 'project'">
                  <template v-if="isLearningCenterSource(scope.row)">
                    <span class="training-instruction-record__empty">-</span>
                  </template>
                  <template v-else-if="scope.row.projectid">
                    <span>{{ scope.row.project_name }}</span>
                    <span class="training-instruction-record__sub-id">/ {{ scope.row.projectid }}</span>
                  </template>
                  <span v-else
                        class="training-instruction-record__empty">-</span>
                </template>
                <template v-else-if="field.slot === 'subId'">
                  <template v-if="scope.row[field.idKey]">
                    <span>{{ scope.row[field.nameKey] }}</span>
                    <span class="training-instruction-record__sub-id">/ {{ scope.row[field.idKey] }}</span>
                  </template>
                  <span v-else
                        class="training-instruction-record__empty">-</span>
                </template>
                <template v-else-if="field.slot === 'progress'">
                  <template v-if="hasLearningProgress(scope.row)">
                    <div class="training-instruction-record__progress">
                      <div class="training-instruction-record__progress-track">
                        <div class="training-instruction-record__progress-bar"
                             :style="{ width: getLearningProgress(scope.row) + '%' }" />
                      </div>
                      <span class="training-instruction-record__progress-text">{{ getLearningProgress(scope.row) }}%</span>
                    </div>
                  </template>
                  <span v-else
                        class="training-instruction-record__empty">-</span>
                </template>
                <span v-else-if="field.slot === 'score'">
                  <span v-if="isOpenBookExamRow(scope.row)"
                        class="training-instruction-record__empty">-</span>
                  <span v-else-if="hasExaminationScore(scope.row)"
                        :class="['training-instruction-record__score', getExamScoreClass(scope.row)]">
                    {{ scope.row.examination_score }}分
                  </span>
                  <span v-else
                        class="training-instruction-record__empty">-</span>
                </span>
                <span v-else-if="field.slot === 'datetime'"
                      :class="{ 'training-instruction-record__empty': !scope.row[field.prop] }">
                  {{ scope.row[field.prop] || '-' }}
                </span>
                <template v-else>
                  {{ field.formatter ? field.formatter(scope.row) : scope.row[field.prop] }}
                </template>
              </template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="100"
                             align="center">
              <template v-slot="scope">
                <router-link v-if="canViewExamDetail(scope.row)"
                             :to="getExamDetailLink(scope.row)"
                             class="training-instruction-record__action-link">
                  查看答卷
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>

    <table-column-config-dialog :visible.sync="tableColumnConfigDialogVisible"
                                :applied-columns="tableColumnAppliedConfig"
                                :definitions="fields"
                                @save="onTableColumnConfigSave" />
  </div>
</template>

<script>
import tableMixin from '@core/mixins/table-v3'
import dateTimePicker from '@core/mixins/dateTimePicker'
import tableColumnConfig from '@core/mixins/table-column-config'
import {
  opts,
  consts,
  TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY,
} from '@views/training/training-instruction-record.constants'
import { createTrainingInstructionRecordTableFields } from '@views/training/training-instruction-record-table.fields'
import { opts as instructionOpts, consts as instructionConsts } from '@views/training/training-instruction.constants'
import { consts as examConsts } from '@views/training/training-exam.constants'
import TrainingInstructionSubHeading from '@views/training/components/TrainingInstructionSubHeading.vue'

const FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align']

export default {
  components: {
    TrainingInstructionSubHeading,
  },
  mixins: [tableMixin, dateTimePicker, tableColumnConfig],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      opts,
      consts,
      targetUserMaps: instructionOpts.targetUserMaps,
      chinaAreaData: [],
      instruction: {
        id: this.$route.params.id,
        title: this.$route.query.title || '',
        passingScore: 60,
      },
      search: {
        keyword: '',
        instruction_record_status: null,
        target_usertype: null,
        source_type: null,
        projectid: null,
        batchid: null,
        regionids: [],
        learning_finished_at: [],
        examination_submitted_at: [],
      },
      searchFieldType: {
        instruction_record_status: Number,
        target_usertype: Number,
        source_type: Number,
        projectid: Number,
        batchid: Number,
        regionids: Array,
        learning_finished_at: Array,
        examination_submitted_at: Array,
      },
      exportHeader: [
        { key: 'id', text: '记录ID' },
        { key: 'training_instruction_title', text: '培训标题' },
        { key: 'userid', text: '用户ID' },
        { key: 'realname', text: '真实姓名' },
        { key: 'region_name', text: '省市区' },
        { key: 'target_usertype_name', text: '用户类型' },
        { key: 'source_type_name', text: '来源' },
        { key: 'project_name', text: '项目' },
        { key: 'batch_name', text: '批次' },
        { key: 'task_title', text: '任务' },
        { key: 'instruction_record_status_name', text: '培训状态' },
        {
          key: 'learning_progress',
          text: '学习进度',
          formatter: (row) => (this.hasLearningProgress(row) ? `${this.getLearningProgress(row)}%` : '-'),
        },
        {
          key: 'examination_score',
          text: '考试分数',
          formatter: (row) => (this.hasExaminationScore(row) ? `${row.examination_score}分` : '-'),
        },
        { key: 'learning_started_at', text: '开始学习时间' },
        { key: 'learning_finished_at', text: '完成学习时间' },
        { key: 'examination_submitted_at', text: '考试提交时间' },
      ],
      fields: createTrainingInstructionRecordTableFields(this),
    }
  },
  computed: {
    pageHeadingTitle () {
      const title = this.instruction.title || this.$route.query.title
      return title ? `用户培训记录 · ${title}` : '用户培训记录'
    },
    pageTitle () {
      return `${this.pageHeadingTitle} ID：${this.instruction.id}`
    },
    activeTableFields () {
      const fieldMap = _.keyBy(this.fields, 'key')
      return this.activeTableColumns
        .map(column => fieldMap[column.key])
        .filter(Boolean)
    },
  },
  created () {
    this.loadInstruction()
    this.getChinaAreaData()
  },
  methods: {
    getTableColumnStorageKey () {
      return TRAINING_INSTRUCTION_RECORD_TABLE_COLUMN_STORAGE_KEY
    },
    getFieldColumnBind (field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS)
    },
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
    ]),
    loadInstruction () {
      request.common('getTrainingInstruction', { id: this.instruction.id }).then(({ data }) => {
        this.instruction.title = data.title
        const examinationJson = data.training_examination_json || {}
        if (examinationJson.passing_score) {
          this.instruction.passingScore = Number(examinationJson.passing_score)
        }
      }).catch(() => {})
    },
    getRouterQueryParams (query = this.$route.query) {
      return tableMixin.methods.getRouterQueryParams.call(this, query)
    },
    getTableData (params) {
      delete params.id
      delete params.title
      delete params.recordId
      params.training_instruction_id = this.instruction.id
      params.record_list_type = 'learning'
      return request.page('queryTrainingInstructionRecord', params)
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    },
    isOpenBookExamRow (row) {
      return Number(row.open_book_exam) === examConsts.OPEN_BOOK_EXAM_OPEN
    },
    hasExaminationScore (row) {
      return Number(row.examination_status) > consts.EXAMINATION_STATUS_NOT_START
    },
    canViewExamDetail (row) {
      return Number(row.examination_status) > consts.EXAMINATION_STATUS_NOT_START
    },
    getExamDetailLink (row) {
      return {
        path: `/training/instruction/exam-records/${this.instruction.id}/detail/${row.id}`,
        query: { title: this.instruction.title },
      }
    },
    hasLearningProgress (row) {
      return row.learning_progress !== null && row.learning_progress !== undefined && row.learning_progress !== ''
    },
    getLearningProgress (row) {
      if (!this.hasLearningProgress(row)) {
        return null
      }
      const progress = Number(row.learning_progress)
      if (Number.isNaN(progress)) {
        return 0
      }
      return Math.min(100, Math.max(0, progress))
    },
    isLearningCenterSource (row) {
      return Number(row.source_type) === consts.SOURCE_TYPE_LEARNING_CENTER
    },
    getUserTypeTagClass (value) {
      const type = Number(value)
      if (type === instructionConsts.TARGETUSER_TYPE_INTERN) {
        return 'is-intern'
      }
      if (type === instructionConsts.TARGETUSER_TYPE_USER) {
        return 'is-worker'
      }
      return 'is-default'
    },
    getSourceTypeTagClass (value) {
      const map = {
        [consts.SOURCE_TYPE_TASK]: 'is-task',
        [consts.SOURCE_TYPE_LEARNING_CENTER]: 'is-learning-center',
        [consts.SOURCE_TYPE_ASSIGN]: 'is-assign',
      }
      return map[Number(value)] || 'is-default'
    },
    getRecordStatusTagClass (value) {
      const map = {
        [consts.STATUS_LEARNING]: 'is-learning',
        [consts.STATUS_LEARN_FINISHED]: 'is-learned',
        [consts.STATUS_WAIT_EXAM]: 'is-wait-exam',
        [consts.STATUS_ON_EXAM]: 'is-examining',
        [consts.STATUS_PASSED]: 'is-passed',
        [consts.STATUS_EXAM_NOT_PASS]: 'is-failed',
        [consts.STATUS_EXAM_WAIT_RETRY]: 'is-retry',
      }
      return map[Number(value)] || 'is-default'
    },
    getExamScoreClass (row) {
      const score = Number(row.examination_score)
      if (Number(row.examination_status) === consts.EXAMINATION_STATUS_PASS) {
        return 'is-pass'
      }
      if (Number(row.examination_status) === consts.EXAMINATION_STATUS_NOT_PASS) {
        return 'is-fail'
      }
      return score >= this.instruction.passingScore ? 'is-pass' : 'is-fail'
    },
    onExport () {
      const params = Object.assign({}, this.search, {
        training_instruction_id: this.instruction.id,
      })
      this.$export(this.pageTitle, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.training-instruction-record {
  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .training-instruction-record__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 4px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 0 16px 16px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }

      &::before {
        display: none;
      }
    }
  }

  &__tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;

    &.is-worker {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &.is-intern {
      background: #ede9fe;
      color: #6d28d9;
    }

    &.is-task {
      background: #e0e7ff;
      color: #4338ca;
    }

    &.is-learning-center {
      background: #cffafe;
      color: #0e7490;
    }

    &.is-assign {
      background: #f3e8ff;
      color: #7e22ce;
    }

    &.is-learning {
      background: #dbeafe;
      color: #1d4ed8;
    }

    &.is-learned {
      background: #dcfce7;
      color: #15803d;
    }

    &.is-wait-exam {
      background: #fef9c3;
      color: #a16207;
    }

    &.is-examining {
      background: #ffedd5;
      color: #c2410c;
    }

    &.is-passed {
      background: #d1fae5;
      color: #047857;
    }

    &.is-failed,
    &.is-retry {
      background: #fee2e2;
      color: #dc2626;
    }

    &.is-default {
      background: #f3f4f6;
      color: #6b7280;
    }
  }

  &__sub-id {
    margin-left: 4px;
    color: #c0c4cc;
    font-size: 12px;
    font-family: Menlo, Monaco, Consolas, monospace;
  }

  &__empty {
    color: #c0c4cc;
  }

  &__progress {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 140px;
  }

  &__progress-track {
    flex: 1;
    min-width: 80px;
    height: 8px;
    background: #e5e7eb;
    border-radius: 999px;
    overflow: hidden;
  }

  &__progress-bar {
    height: 100%;
    background: #2563eb;
    border-radius: 999px;
    transition: width 0.2s ease;
  }

  &__progress-text {
    flex-shrink: 0;
    color: #606266;
    font-size: 13px;
    white-space: nowrap;
  }

  &__score {
    font-weight: 500;

    &.is-pass {
      color: #16a34a;
    }

    &.is-fail {
      color: #dc2626;
    }
  }

  &__action-link {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    color: #409eff;
    text-decoration: none;

    &:hover {
      background: #ecf5ff;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

@media (max-width: 1200px) {
  .training-instruction-record {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .training-instruction-record {
    &__search-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.training-instruction-record__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/instruction/TrainingInstructionRecordTable.vue